import React, { FC, Fragment, memo, useCallback } from 'react'
import { Banner } from '../../Banner/desktop'

import { IInstitutionsListProps } from '../types'
import { InstitutionsListItem } from './InstitutionsListItem'
import SC from '../base/InstitutionsList.styles'

const { Block } = SC

/** Список вузов */
const InstitutionsList: FC<IInstitutionsListProps> = (props) => {
  const {
    isBanner = false,
    isLogo = true,
    params,
    items,
    specialityId,
    shortName,
    tagId,
    specialityIds,
    activeProgramType,
  } = props

  const showBanner = useCallback(
    (index: number) => {
      if (isBanner && items && items?.length < 3) {
        return items.length - 1 === index
      }
      if (isBanner && items) {
        return index === 2
      }
      return false
    },
    [items, isBanner]
  )

  return (
    <Block>
      {items.map((institution, index) => {
        const isDivider = true

        return (
          <Fragment key={institution.id}>
            <InstitutionsListItem
              {...institution}
              isDivider={isDivider}
              isLogo={isLogo}
              specialityId={specialityId}
              shortName={shortName}
              tagId={tagId}
              specialityIds={specialityIds}
              activeProgramType={activeProgramType}
            />

            {showBanner(index) && (
              <li>
                <Banner id={2} extraParams={params} />
              </li>
            )}
          </Fragment>
        )
      })}

      {isBanner && items.length === 0 && (
        <li>
          <Banner
            id={2}
            extraParams={params}
            spacing={{
              bottom: 'xlarge',
              top: 'xlarge',
            }}
          />
        </li>
      )}
    </Block>
  )
}

export { InstitutionsList }
export default memo(InstitutionsList)
